// @ts-nocheck

/* eslint-disable sonarjs/no-duplicate-string */
import { __ } from '../../../i18n/l10n';
import { GRBasketErrorCodes } from '../types/errorCode';
import { GRRounds } from '../types/round';

// __('Bet is not eligible for the Gift Race because the game is not in progress')
// __('Bet is not eligible for the Gift Race because you have not started the game')
// __('Bet is not eligible for the Gift Race because you must start the gift quest again')
// __('Bet is not eligible for the Gift Race because you have a reward to collect in order to unlock the next gift')
// __('Bet is not eligible for the Gift Race because system bets are not eligible')
// __('Bet is not eligible for the Gift Race because you have already placed an eligible bet on the same match')
// __('Bet is not eligible for the Gift Race because the match starts in over 48 hours')
// __('Bet is not eligible for the Gift Race because your current bets will be decisive')
// __('Bet is not eligible for the Gift Race because at least one match starts after the end of the game')
// __('Bet is not eligible for the Gift Race because this version of the game has ended')
// __('Bet is not eligible for the Gift Race because you have already won the gift')

export const getGRErrorLabelsByErrorCode = () =>
  new Proxy(
    {
      [GRBasketErrorCodes.E_OP_NOT_RUNNING]: __(
        'Bet is not eligible for the Gift Race because the game is not in progress',
      ),
      [GRBasketErrorCodes.E_USER_NOT_IN]: __(
        'Bet is not eligible for the Gift Race because you have not started the game',
      ),
      [GRBasketErrorCodes.E_SYSTEM_FORBIDDEN]: __(
        'Bet is not eligible for the Gift Race because system bets are not eligible',
      ),
      [GRBasketErrorCodes.E_MATCH_PENDING]: __(
        'Bet is not eligible for the Gift Race because you have already placed an eligible bet on the same match',
      ),
      [GRBasketErrorCodes.E_START_DATE_OVER_48]: __(
        'Bet is not eligible for the Gift Race because the match starts in over 48 hours',
      ),
      [GRBasketErrorCodes.E_BETSLIP_NOT_ELIGIBLE]: __('Bet is not eligible for the Gift Race'),
      [GRBasketErrorCodes.E_INTERNAL_ERROR]: __('Gift Race internal error'),
      [GRBasketErrorCodes.E_START_DATE_OVER_OPE]: __(
        'Bet is not eligible for the Gift Race because at least one match starts after the end of the game',
      ),
      [GRBasketErrorCodes.E_USER_EXCLUDED]: __('You are currently ineligible for the Gift Race'),
      [GRBasketErrorCodes.E_ALREADY_PAID]: __('You have already received your reward'),
      [GRBasketErrorCodes.E_PAYMENT_ERROR]: __('Error whilst crediting your reward'),
      [GRBasketErrorCodes.E_ALREADY_REGISTERED]: __('Your participation in the game has already been validated'),
      [GRBasketErrorCodes.E_ES_RM_J30]: __('!desc:%1$s ES RM J-30 warning', 'Atención:'),
      [GRBasketErrorCodes.E_SELF_EXCLUDED]: __('You are currently excluded from the Gift Race due to your game limits'),
    },
    {
      get(origin, key) {
        if (!origin[key]) {
          return __('An error has occured');
        }
        return origin[key];
      },
    },
  );

// __('You will earn between %1$s and %2$s times your reference bet in Freebets.')
// __('Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.')
export const getGRRulesByRound = (maxPoints, minStakeMultiplicator, maxStakeMultiplicator) => ({
  [GRRounds.SHOE]: {
    title: __('Phase 1: Pegasus Shoes'),
    rules: [
      <>{__('Place a series of winning bets to score %1$s points.', maxPoints)}</>,
      <>
        {__(
          'Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.',
        )}
      </>,
      <>
        {__('You will earn between %1$s and %2$s times your reference bet in Freebets.', [
          minStakeMultiplicator,
          maxStakeMultiplicator,
        ])}
      </>,
      <>{__('And you will unlock phase 2.')}</>,
      <>{__('If you lose a bet, you start the phase from 0.')}</>,
    ],
  },
  [GRRounds.BALLOON]: {
    title: __('Phase 2: The remote control ball'),
    rules: [
      <>{__('Place a series of winning bets to score %1$s points.', maxPoints)}</>,
      <>
        {__(
          'Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.',
        )}
      </>,
      <>
        {__('You will earn between %1$s and %2$s times your reference bet in Freebets.', [
          minStakeMultiplicator,
          maxStakeMultiplicator,
        ])}
      </>,
      <>{__('And you will unlock phase 3.')}</>,
      <>{__('If you lose a bet, you start the phase from 0.')}</>,
    ],
  },
  [GRRounds.SHIRT]: {
    title: __('Phase 3: The Chameleon Jersey'),
    rules: [
      <>{__('Place a series of winning bets to score %1$s points.', maxPoints)}</>,
      <>
        {__(
          'Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.',
        )}
      </>,
      <>
        {__('You will earn between %1$s and %2$s times your reference bet in Freebets.', [
          minStakeMultiplicator,
          maxStakeMultiplicator,
        ])}
      </>,
      <>{__('If you lose a bet, you start the phase from 0.')}</>,
    ],
  },
});
